<template>
  <div class="strip-wrap">
    <div id="strip" style="width: 100%; height: 800px"></div>
    <div class="reload" @click="reload">
      <i class="el-icon-refresh-right"></i>重播
    </div>
  </div>
</template>
<style scoped>
.strip-wrap {
  position: relative;
}
.reload {
  position: absolute;
  right: 60px;
  bottom: 120px;
  color: #999;
  cursor: pointer;
}
</style>
<script>
import * as echarts from "echarts";
import data from "@/mock/numhis_char2.json";
let timer;
let colors = [
  "#80bbf9",
  "#74608f",
  "#d7a02b",
  "#c8ba23",
  "#4D670C",
  "#70ab52",
  "#1F814A",
  "#357F88",
  "#673509",
  "#310937",
  "#1B9637",
  "#F7393C",
];
colors = colors.concat(colors);
const labels = data.ydata.map((item) => item.name);
let showLabels = [];
let values = Array.apply(null, { length: data.ydata.length }).map(() => 0);
let year;
let count = 0;
export default {
  data() {
    return {
      timer: null,
    };
  },
  mounted() {
    this.initStrip();
    this.runAnimationnStrip()
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    getGtValues(){
      showLabels = []
      for(let i;i < labels.length;i++){
        values[i] > 0 && showLabels.push(labels[i])
      }
    },
    reload() {
      this.timer && clearInterval(this.timer);
      count = 0;
      values = Array.apply(null, { length: data.ydata.length }).map(() => 0);
      this.initStrip();
      this.runAnimationnStrip()
    },
    runAnimationnStrip() {
      this.timer = setInterval((_) => {
        if (count < data.xdata.length) {
          showLabels = [];
          for (let i = 0; i < data.ydata.length; i++) {
            values[i] += data.ydata[i].datas[count];
            values[i] > 0 && showLabels.push(labels[i])
          }
          year = data.xdata[count];
          count++;
          this.initStrip();
        } else {
          this.timer && clearInterval(this.timer);
        }
      }, 1000);
    },
    initStrip() {
      var chartDom = document.getElementById("strip");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "数字化资源加工历程",
          x: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          // type: "value",
          boundaryGap: [0, 0.1],
          // data: data.xdata
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: showLabels,
          axisLabel: {
            show: true,
            formatter: function (n) {
              return n;
            },
          },
        },
        series: [
          {
            realtimeSort: true,
            type: "bar",
            data: values.map(value => value),
            itemStyle: {
              normal: {
                color: function (params) {
                  // 给出颜色组
                  var colorList = colors;
                  return colorList[params.dataIndex];
                },
                label: {
                  show: true,
                  precision: 1,
                  position: "right",
                  valueAnimation: true,
                  fontFamily: "monospace",
                },
              },
            },
          },
        ],
        graphic: {
          elements: [
            {
              type: "text",
              right: 60,
              bottom: 160,
              style: {
                text: year,
                font: "bolder 80px monospace",
                fill: "rgba(100, 100, 100, 0.25)",
              },
              z: 100,
            },
          ],
        },
        animationDuration: 0,
        animationDurationUpdate: 2000,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
      };
      option && myChart.setOption(option);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/components/strip.vue